import { useMemo } from "react";
import { useSelector } from "react-redux";
import getStrings from "../localization/getStrings";

/*
 * `getStrings` is a synchronous lookup, so the strings are ready on the first render. They used to
 * be set in an effect, which made `strings` start as undefined: every effect with `strings` in its
 * dependencies ran twice on mount and sent its API requests twice.
 */
const useLang = (screen: string) => {
	const lang = useSelector((state: any) => state.langReducer.lang);
	const strings = useMemo<any>(
		() => getStrings(screen, lang),
		[screen, lang]
	);
	return { strings, lang };
};

export default useLang;
